export function getSiteKey() {
  return process.env.GOOGLE_RECAPTCHA_SITE_KEY;
}